import type { ReactNode } from 'react';
import { AuthProvider } from 'react-oidc-context';
import { gestorSesion } from './gestor';

// Pone la sesión a disposición de toda la aplicación.
//
// Se le pasa el gestor ya construido en vez de dejar que `AuthProvider` arme el
// suyo con props sueltas. Así el token tiene **una sola fuente**: la misma que
// lee `api.ts` para firmar las peticiones. Con dos gestores habría dos sesiones
// renovándose por separado y pisándose en el almacenamiento.

interface Props {
  children: ReactNode;
}

export function ProveedorSesion({ children }: Props) {
  return (
    <AuthProvider
      userManager={gestorSesion}
      // Qué hacer cuando Keycloak devuelve a la persona a la aplicación.
      //
      // **Limpiar la dirección importa más de lo que parece.** Al volver, la URL
      // trae `?code=…&state=…` colgando. Si se deja:
      //
      //   - recargar la página reintenta canjear un código ya usado, y eso
      //     falla con un error que no dice nada de lo que pasó;
      //   - el código queda en el historial del navegador y en cualquier
      //     captura de pantalla.
      //
      // `replaceState` lo borra sin agregar una entrada al historial, así que el
      // botón de atrás sigue haciendo lo que la persona espera.
      onSigninCallback={() => {
        window.history.replaceState({}, document.title, window.location.pathname);
      }}
    >
      {children}
    </AuthProvider>
  );
}
